import { sessionState } from 'src/app/core/services/signal-state.storage';
import { AppService } from './../app.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, DestroyRef, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { IAcctDetail } from '../shared/Models/Interfaces';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-app-main-component',
    templateUrl: './app-main-component.component.html',
    styleUrls: ['./app-main-component.component.scss'],
    standalone: false
})
export class AppMainComponentComponent implements OnInit {
  @ViewChild(MatSidenav)
  sidenav!: MatSidenav;
  public isLeftMenuVisible: boolean = true;
  acctDetail: IAcctDetail | null = null;
  accountExist: boolean = true
  isGdoPortalActive: boolean = false;
  userName: string | null = "NA"
  userEmail: string | null = "NA"

  constructor(
    private observer: BreakpointObserver,
    private _appService: AppService,
    private destroyRef: DestroyRef
  ) { }

  ngOnInit(): void {
    this.isLeftMenuVisible = this._appService.isLeftMenuVisible;
    
    this.isGdoPortalActive = this._appService.isGdoPortal;
  }

  ngAfterViewInit() {
    this.observer.observe(['(max-width: 700px)']).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      if (res.matches) {
        this.sidenav.mode = 'over';
        this.sidenav.close();
      } else {
        this.sidenav.mode = 'side';
        this.sidenav.open();
      }
    });

    this._appService.checkIsDataAvailable().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      setTimeout(() => {
        if (res) {
          this.accountExist = true
          this.acctDetail = this._appService.getAccDetails()
        } else {
          this.accountExist = false
          this.userName = sessionState.getItem("first_name")
          this.userEmail = sessionState.getItem("email")
        }
      }, 1);
    });
  }

}
